import React, { PureComponent } from "react";
import { Upload, Select, Table, Checkbox, Button,Dialog } from "element-react";
import { Link } from "react-router-dom";
import uploadImg from 'images/preferential/upload.png';
import download from 'images/preferential/download.png';

import './index.scss'
const city = [
  { value: "三亚市", label: "三亚市" },
  { value: "海口市", label: "海口市" },
  { value: "三沙市", label: "三沙市" }
];

const area = [
  { value: "海棠区", label: "海棠区" },
  { value: "吉阳区", label: "吉阳区" },
  { value: "天涯区", label: "天涯区" }
];

const areaSmall = [
  { value: "蓝翔退役军人培训中心", label: "蓝翔退役军人培训中心" },
  { value: "青鸟退役军人培训中心", label: "青鸟退役军人培训中心" },
  { value: "非凡退役军人培训中心", label: "非凡退役军人培训中心" }
];

export default class TrainingHandle extends PureComponent {
  state = {
    value: "",
    dialogVisible: false,
    ischecked:false,
  };

  render() {
   
    const columns = [
      {
        type: 'index',
        label: "序号",
        align: 'center'
      },
      {
        label: "材料名称",
        prop: "name",
        align: 'center'
      },
      {
        label: "材料要求",
        prop: "command",
        align: 'center',
        render(row) {
          return (<div style={{ color: '#18388c' }}>{row.command}</div>)
        }
      },
      {
        label: '原件',
        prop: 'origin',
        align: 'center'
      },
      {
        label: '复印件',
        prop: 'copy',
        align: 'center'
      }, {
        label: '范本文件',
        prop: 'file',
        align: 'center',
        render(row) {
          return (
            <div style={{  display: 'flex',alignItems:'center',justifyContent:'center'}}>
                <img src={download} style={{ marginRight: '5px' }} />
                <span style={{cursor: 'pointer',color: '#18388c'}}>{row.file}</span>
            </div>
            )
        }
      },
      {
        label: '上传附件',
        prop: 'upload',
        align: 'center',
        render(row) {
          return (
            <Upload
                className="upload-demo"
                style={{  display: 'flex',alignItems:'center',justifyContent:'center'}}
                onPreview={file =>  console.log(file)}
                onRemove={(file, fileList) =>  console.log(file, fileList)}
                limit={3}
          >
             <img src={uploadImg} style={{ marginRight: '5px' }} />
              <span style={{cursor: 'pointer',color: '#18388c'}}>上传</span>
          </Upload>
          
          )
        }
      }
    ];
    const dataSource = [{
      name: '优抚补贴申请表',
      command: '查看要求',
      upload: '附件',
      file: '范本',
      origin: '1',
      copy: '1'
    }, {
      name: '伤残证',
      command: '查看要求',
      upload: '附件',
      file: '范本',
      origin: '0',
      copy: '1'
    }, {
      name: '退役军人证',
      command: '查看要求',
      upload: '附件',
      file: '范本',
      origin: '0',
      copy: '1'
    }, {
      name: '身份证',
      command: '查看要求',
      upload: '附件',
      file: '范本',
      origin: '0',
      copy: '1'
    }]
    return (
      <div className="main_search_detail">
        <div className="center" style={{ marginTop: '0' }}>
          <div className="center_search">
            <div className="center_position_info"></div>
            <span style={{ color: "#18388c", fontSize: "24px" }}>
                 互联网+软件工程_
            </span>
            <span style={{ lineHeight: "24px", color: "#18388c" }}>
                在线办理
            </span>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>选择办理区域</span>
            </div>
          </div>
          <div className="selected_process_area">
            <span
              style={{ marginRight: "18px", color: "#333", fontSize: "14px" }}
            >
              海南省  三亚市  海棠区  灵山区
            </span>
            {/* <Select>
              {city.map(el => {
                return (
                  <Select.Option
                    key={el.value}
                    label={el.label}
                    value={el.value}
                  />
                );
              })}
            </Select>
            <Select>
              {area.map(el => {
                return (
                  <Select.Option
                    key={el.value}
                    label={el.label}
                    value={el.value}
                  />
                );
              })}
            </Select>
            <Select>
              {areaSmall.map(el => {
                return (
                  <Select.Option
                    key={el.value}
                    label={el.label}
                    value={el.value}
                  />
                );
              })}
            </Select> */}
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请人基本信息</span>
            </div>
          </div>
          <div>
            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>申请人姓名</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <input
                disabled="disabled"
                value="张三"
                className="application_basic_input"
                style={{ background: "#f6f6f6" }}
              ></input>
            </div>

            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>证件号码</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              {/* <input value="身份证" className="application_basic_id"></input> */}
              <input
                disabled="disabled"
                value="429005189876509087"
                className="application_basic_input"
                style={{ background: "#f6f6f6" }}
              ></input>
            </div>

            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>性别</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <input
                type="radio"
                name="sex"
                checked
                value="男"
                className="application_basic_sex"
              />
              <span style={{ marginLeft: "3px", marginRight: "12px" }}>男</span>
              <input
                type="radio"
                name="sex"
                value="女"
                className="application_basic_sex"
              />
              <span>女</span>
            </div>

            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>联系电话</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <input
                value="13212341233"
                className="application_basic_input"
                placeholder="请输入手机号码"
              ></input>
            </div>
        
            <div className="application_basic_info">
              <div className="application_basic_left">
                <span>联系地址</span>
                <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
              </div>
              <input
                value=""
                className="application_basic_input"
                placeholder="例：海南省三亚市西乡塘区大学东路100号"
              ></input>
            </div>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>事项基本信息</span>
            </div>
          </div>
          <div className="item_basic_info">
            <div style={{ marginBottom: "14px" }}>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                  事项名称：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                    海棠区办事处退役军人互联网应用培训
                </span>
              </div>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                  事项编号：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                  4403430000000527999931001001663001
                </span>
              </div>
            </div>
            <div>
              <div className="item_basic_info_block" style={{ float: 'left' }}>
                <span style={{ fontSize: "14px", color: "#333" }}>
                  审批单位：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                  海南省三亚市海棠区退役军人事务处
                </span>
              </div>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                  面向对象：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                     自主择业军队转业干部、自主就业退役士兵
                </span>
              </div>
            </div>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请事项信息</span>
            </div>
          </div>
             <div className="item_basic_info">
            <div style={{ marginBottom: "14px" }}>
              <div className="item_basic_info_block">
                <div className="application_basic_left" style={{width:80}}>
                    <span>培训活动</span>
                    <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
                </div>
                <Select>
                    {areaSmall.map(el => {
                        return (
                        <Select.Option
                            key={el.value}
                            label={el.label}
                            value={el.value}
                        />
                        );
                    })}
              </Select>
              </div>
              <div className="item_basic_info_block">
              <div className="application_basic_left" style={{width:80}}>
                    <span>培训机构</span>
                    <span style={{ color: "#fc0000", marginRight: "16px" }}>*</span>
                </div>
                <Select>
                    {areaSmall.map(el => {
                        return (
                        <Select.Option
                            key={el.value}
                            label={el.label}
                            value={el.value}
                        />
                        );
                    })}
              </Select>
              </div>
            </div>
            <div style={{ marginBottom: "14px" }}>
                <div className="item_basic_info_block" style={{ float: 'left' }}>
                    <span style={{ fontSize: "14px", color: "#333" }}>
                        剩余学位数：
                    </span>
                    <span style={{ fontSize: "14px", color: "#666" }}>
                        36个
                    </span>
                </div>
                <div className="item_basic_info_block">
                    <span style={{ fontSize: "14px", color: "#333" }}>
                        培训费用：
                    </span>
                    <span style={{ fontSize: "14px", color: "#666" }}>
                        6500.00元/人
                    </span>
                </div>
            </div>
            <div >
              <div className="item_basic_info_block" style={{ float: 'left' }}>
                <span style={{ fontSize: "14px", color: "#333" }}>
                     培训时间：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                       2018.11.08~11.15
                </span>
              </div>
              <div className="item_basic_info_block">
                <span style={{ fontSize: "14px", color: "#333" }}>
                 培训地点：
                </span>
                <span style={{ fontSize: "14px", color: "#666" }}>
                海南三亚市海棠区1008号幸福大厦1001
                </span>
              </div>
            </div>        
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>材料清单</span>
            </div>
          </div>

          <div style={{ margin: '20px 19px 40px 19px ' }}>
            <Table
              style={{ width: '100%' }}
              columns={columns}
              data={dataSource}
              border={true}
            />
            <div className="check_agree">
              <Checkbox checked={this.state.ischecked}><span style={{ marginLeft: '5px' }}>我已阅读并同意遵守</span></Checkbox>
              <span style={{cursor: 'pointer', color: '#18388c' }} onClick={()=> 
               this.setState({
                    dialogVisible: true
                    })}>《服务协议》</span>
            </div>
            <div>
              <div className="detail_submit"><Button><Link to='./applicationGuide'><span style={{ color: '#fff' }}>提交</span></Link></Button></div>
              {/* <div className="detail_save"><Button>暂存</Button></div> */}
            </div>
          </div>
        </div>
        {/* 当前位置 */}
        {/* 当前位置 */}
    <Dialog
          customClass="magnifyImgDialog"

          size="tiny"
          visible={this.state.dialogVisible}
          onCancel={() => this.setState({ dialogVisible: false })}
        >
          <Dialog.Body style={{ textAlign:'left',height:400}}>
            <div className="center_search" >
                <span style={{ color: "#18388c", fontSize: "24px" }}>
                服务协议
                </span>
            
            </div>
            <div style={{marginTop:20,display:'flex',flexDirection:'column',paddingLeft:20,}}>
                <div>
                    <span style={{fontSize:20,fontWeight:'bold'}}>畅协议:</span>
                    <p style={{fontSize:16,marginTop:10}}>申请人对所提请行政审批事项的法律、法规和政策依据 ，准予行政审批的条件、标准和技术要求，要提交材料的名称、式和期限等内容，已全部知悉。申请人严格按要求提供相关申请材料，并按广东政务服务网的指引上传。</p>
                </div>
                <div style={{marginTop:10}}>
                    <span style={{fontSize:20,fontWeight:'bold'}}>申请人郑重承诺:</span>
                    <p style={{fontSize:16,marginTop:10}}>上传的申请材料、证件扫描件与书面申请材料、证件原件一致，均客观真实、合法有效,不存在隐瞒、伪造、篡改等任何违法情形。申请人愿意按审批流程要求现场提交书面申请材料供校验核对，如上传材料与现场提交书面材料不一致或存在隐瞒、伪造、篡改等违法情形，意承担一切法律后果,包括但不限于终止审批流程、撤销审批结果以及相应的行政处罚或刑事责任。</p>
                </div>
            </div>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',marginTop:20,}} >
              <div style={{width: 78,height: 36,display:'flex',justifyContent:'center',alignItems:'center',backgroundColor: '#18388c',borderRadius: 4,cursor: 'pointer',}} onClick={()=>this.setState({ischecked:true,dialogVisible:false})}><span style={{ color: '#fff' }}>同意</span></div>
              <div style={{width: 78,height: 36,display:'flex',justifyContent:'center',alignItems:'center',backgroundColor: '#fff',borderRadius: 4,marginLeft:10,cursor: 'pointer',}} onClick={()=>this.setState({ischecked:false,dialogVisible:false})}><span style={{ color: '#666666' }}>不同意</span></div>
            </div>
          </Dialog.Body>
        </Dialog>
      </div>
    );
  }
}
